import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "isHighlighted", "isLoading", "onClick", "testId", "theme", "tooltip"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import ChevronIcon from '@atlaskit/icon/utility/chevron-down';
import ChevronIconMigration from '@atlaskit/icon/utility/migration/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
import { PrimaryButton } from '../PrimaryButton';
/**
 * __Primary dropdown button__
 *
 * A primary dropdown button allows you to add dropdown menus to the navigation.
 * Should be passed into `AtlassianNavigation`'s `primaryItems` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#button)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var PrimaryDropdownButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var component = props.component,
    isHighlighted = props.isHighlighted,
    isLoading = props.isLoading,
    onClick = props.onClick,
    testId = props.testId,
    theme = props.theme,
    tooltip = props.tooltip,
    rest = _objectWithoutProperties(props, _excluded);
  return jsx(PrimaryButton, _extends({
    component: component,
    iconAfter:
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('platform-component-visual-refresh') ? jsx(ChevronIcon, {
      label: "",
      color: "currentColor"
    }) : jsx(ChevronIconMigration, {
      LEGACY_margin: "0 ".concat("var(--ds-space-negative-050, -4px)", " 0 ", "var(--ds-space-negative-100, -8px)"),
      color: "currentColor",
      label: ""
    }),
    isHighlighted: isHighlighted,
    isLoading: isLoading,
    onClick: onClick,
    ref: ref,
    testId: testId
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    theme: theme,
    tooltip: tooltip
    // These are mostly explicit, leaving it in just in case
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest));
});
export default PrimaryDropdownButton;